// Questionnaire data structure

export const stateGroups = {
  north: {
    name: 'North',
    states: ['Delhi', 'Punjab', 'Haryana', 'Uttar Pradesh', 'Rajasthan'],
    electricityRate: 8.5, // Average rate in rupees per unit
    icon: '🏔️'
  },
  south: {
    name: 'South',
    states: ['Karnataka', 'Tamil Nadu', 'Kerala', 'Andhra Pradesh'],
    electricityRate: 7.5, // Average rate in rupees per unit
    icon: '🌴'
  },
  east: {
    name: 'East',
    states: ['Bihar', 'West Bengal', 'Odisha', 'Jharkhand'],
    electricityRate: 8.0, // Average rate in rupees per unit
    icon: '🌅'
  },
  west: {
    name: 'West',
    states: ['Maharashtra', 'Gujarat', 'Madhya Pradesh'],
    electricityRate: 9.5, // Average rate in rupees per unit
    icon: '🌊'
  }
};

export const systemCapacities = [
  { kw: 2, cost: 140000, subsidy: 60000 },
  { kw: 3, cost: 210000, subsidy: 78000 },
  { kw: 4, cost: 270000, subsidy: 78000 },
  { kw: 5, cost: 325000, subsidy: 78000 },
  { kw: 10, cost: 590000, subsidy: 78000 }
];

export const systemTypes = {
  'on-grid': {
    name: 'On-Grid Solar System',
    description: 'Connected to the main electricity grid',
    benefits: [
      'Excess electricity sent to grid during day',
      'Draw electricity from grid at night',
      'Net metering reduces your bill',
      'No battery storage needed',
      'Lower initial cost'
    ],
    explanation: 'During the day, your solar panels generate electricity. If you use less than you generate, the excess is sent to the grid. At night, you draw electricity from the grid. Your bill is calculated based on net usage (units consumed minus units generated).'
  },
  'off-grid': {
    name: 'Off-Grid Solar System',
    description: 'Independent system with battery storage',
    benefits: [
      'Complete independence from grid',
      'Works during power cuts',
      'Battery stores excess energy',
      'No electricity bills',
      'Ideal for remote areas'
    ],
    explanation: 'An off-grid system includes solar panels and battery storage. During the day, panels charge the batteries. At night, you use stored energy. This system is completely independent but requires battery maintenance and has higher initial cost.'
  }
};

export const subsidyInfo = {
  title: 'Government Subsidy Available!',
  description: 'The Government of India offers substantial subsidies on rooftop solar installations through the PM Surya Ghar scheme.',
  amounts: [
    { capacity: '1kW', subsidy: 30000 },
    { capacity: '2kW', subsidy: 60000 },
    { capacity: '3kW or Above', subsidy: 78000 }
  ],
  eligibility: [
    'Solar panels must be made in India',
    'Panels must comply with ALMM specification',
    'The solar system should be a rooftop on-grid solar system'
  ],
  transferInfo: 'The Ministry of New and Renewable Energy (MNRE) transfers the subsidy directly to your bank account within 30 days after local discom inspection.'
};

export const questionSteps = [
  {
    id: 1,
    title: 'What\'s your current monthly electricity bill?',
    subtitle: 'Enter your average monthly bill amount',
    type: 'electricity-bill'
  },
  {
    id: 2,
    title: 'What type of solar system do you prefer?',
    subtitle: 'Choose the option that suits your needs',
    type: 'system-type'
  },
  {
    id: 3,
    title: 'Did you know about government subsidy?',
    subtitle: 'Learn about available benefits',
    type: 'subsidy-info'
  }
];

// Default electricity rate (₹8.5 per unit)
export const DEFAULT_ELECTRICITY_RATE = 8.5;

